import { withFormik } from 'formik';
import { logIn  } from '../../../facades/eagle/user';
import compose from 'recompose/compose';
import withQueryParams from '../../hocs/withQueryParams';
import cookieFactory from '../../../cookieFactory';

/* eslint-disable no-console */
const withLogin = compose(
  withQueryParams,
  withFormik({
    mapPropsToValues: () => ({
      base: '',
      email: '',
      password: '',
    }),
    handleSubmit: (values, actions) => {
      const props = actions.props;
      logIn(values)
        .then(() => {
          cookieFactory('isAuthenticated', null, true).set();
          window.top.location = props.queryParams.return_to || '/';
        })
        .catch(err => {
          actions.setSubmitting(false);
          const errors = err.details.errors;
          switch (err.status) {
            case 401:
              actions.setFieldError('base', errors[0].detail);
          }
        });
    },
  }),
);
/* eslint-enable no-console */

export default withLogin;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withLogin.js